import { TokenExCardTypes } from '@givebacks/api/core';
import { Box, Group, Stack, Title } from 'ui';

import { CardInfoFields } from './CardInfoFields/CardInfoFields';

type TokenExCardInfoFormProps = {
  title?: string;
  onCredentialChange: (credential?: TokenExCardTypes) => void;
};

const TokenExCardInfoForm = ({
  title = 'Debit or Credit Card',
  onCredentialChange,
}: TokenExCardInfoFormProps) => {
  return (
    <Stack>
      <Group gap={4}>
        <Title order={4}>{title}</Title>
        <Box c="cerise.7" fz={'sm'} fw={500}>
          *
        </Box>
      </Group>
      <CardInfoFields onCredentialChange={onCredentialChange} />
    </Stack>
  );
};

export { TokenExCardInfoForm };
